const e=["xs","sm","md","lg","xl"],r=(r,s)=>e.reduce(((e,t)=>{const c=s?.[t];return{...e,[`${r}-${t}-${c}`]:c}}),{});export{r as generateColClassNames};
